export default "/dist/files/choix_animation_quiz.9598b7eca0711ebf57e988e506ac8966.svg";